import { render, staticRenderFns } from "./FamilyPrintModal.vue?vue&type=template&id=20eccc11"
import script from "./FamilyPrintModal.vue?vue&type=script&lang=js"
export * from "./FamilyPrintModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports